var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0));
},"3":function(container,depth0,helpers,partials,data) {
    return "<i>"
    + container.escapeExpression(__default(require("../../helpers/t.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Unnamed feature",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":1,"column":46},"end":{"line":1,"column":69}}}))
    + "</i>";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a href='#'>"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"hasName") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":12},"end":{"line":1,"column":80}}})) != null ? stack1 : "")
    + " <small class=\"text-right\">("
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"geometry") : depth0)) != null ? lookupProperty(stack1,"type") : stack1), depth0))
    + ")</small></a>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /src/views/filters/FeatureListItemView.hbs
// module id = 2075
// module chunks = 0